module.exports = __webpack_public_path__ + "static/media/OneMoreRepSS.a81deff0.png";